import Flourish from 'components/flourish';
import { Box, Heading, Image } from 'components/ui';
import { FC } from 'react';
import styled from 'styled-components';

interface DecorationProps {
  image?: string;
}

const minvw = (val: number) =>
  `min(${val}vw, calc(${val / 100} * var(--size-main)))`;

const Wrapper = styled.div`
  position: relative;
  padding-bottom: ${minvw(10)};
  padding-left: ${minvw(20)};
  isolation: isolate;

  > * {
    &:nth-child(1) {
      position: absolute;
      top: calc(50% - ${minvw(5)});
      left: 0;
      z-index: 1;
      width: ${minvw(30)};
      background: none;
      transform: translateY(-50%);
    }
  }
`;

const TextBox = styled(Box)`
  --padding: 0;
  --background-color: rgba(0, 0, 0, 0.5);
  --color: var(--color-white);

  position: absolute;
  right: ${minvw(5)};
  bottom: 0;
  width: ${minvw(20)};
  height: 0;
  padding-bottom: ${minvw(20)};
  text-align: center;
  border: clamp(4px, ${minvw(1)}, 16px) solid var(--color-white);
  aspect-ratio: 1 / 1;

  * {
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 10%;
    font-size: ${minvw(3)};
    background: none;
    transform: translate(-50%, -50%);
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 50%;
`;

const Decoration: FC<DecorationProps> = ({ image }) => {
  return (
    <Wrapper>
      <Flourish variant='small' />
      <ImageWrapper>
        {/* Alt text has been hardcoded here in line with the hard coding of the image source,  */}
        <Image
          src={image ? image : '/decoration.jpg'}
          layout='fill'
          alt={
            'A woman laying on the floor next to a monstera leaf at Salon Studios'
          }
          objectFit='cover'
        />
      </ImageWrapper>
      <TextBox>
        <Heading level='h3' as='h2'>
          Your place to thrive
        </Heading>
      </TextBox>
    </Wrapper>
  );
};

export default Decoration;
